import { useState, useEffect } from "react";
import { Button } from "../../../components/Button";
import { Flex } from "../../../components/Flex";
import { useFormSections } from "../../../data/useFormSections";
import { useNavigate, useParams } from "react-router-dom";
import { ROUTE } from "../../../routes";
import { H3, H4 } from "../../../components/Heading";
import { useForm } from "../../../data/useForm";
import { Loader } from "../../../components/Loader";
import { Box } from "../../../components/Box";
import { Paragraph } from "../../../components/Paragraph";
import { GrayCard } from "../../../components/Card";
import { useQuestionsFiledTypeList } from "../../../data/useQuestionsFiledTypeList";
import { Image } from "../../../components/Image";
import * as icons from "../../../assets/questions";

const SettingsSummaryView = ({ initialFormData = null }) => {
  const params = useParams();
  const navigate = useNavigate();
  const { data: form, isLoading } = useForm(parseInt(params.id));
  const { data: sections, isLoading: isSectionsLoading } = useFormSections(
    parseInt(params.id)
  );
  const { data: questionsFieldTypeList } = useQuestionsFiledTypeList();

  const [editingSectionIndex] = useState(null);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    _type: "",
    sections: [],
  });

  useEffect(() => {
    if (form && sections) {
      setFormData({
        title: form.data?.name || "",
        description: form.data?.description || "",
        _type: form.data?._type || "",
        sections,
      });
    }
  }, [form, sections]);

  return (
    <>
      {isLoading || isSectionsLoading ? (
        <Flex justifyContent="center" alignItems="center" minHeight="25vh">
          <Loader />
        </Flex>
      ) : (
        <Box
          bg="white"
          width="96%"
          flexWrap="wrap"
          borderRadius="16px"
        >
          <H3 fontSize="3">
            Summary
          </H3>
          <Flex justifyContent="space-between" alignItems="center">
            <H4 mb="0">{formData.title}</H4>
          </Flex>
          <Flex mb={3} justifyContent="space-between" alignItems="center">
            <Paragraph mt="0">{formData.description}</Paragraph>
          </Flex>
          {sections.map((section, index) => (
          <GrayCard m={2} key={index}>
                <H3 color="gray.80" my="2" fontSize="2">
                  Section {index + 1}
                </H3>
                <Paragraph fontSize={1} color={"gray.60"}>
                  {section.description}
                </Paragraph>
                {section.questions.map((question, qIndex) => {
              return (
                <Flex key={qIndex} gap="12" alignItems={"center"}>
                  <Image
                    src={
                      icons[
                      question.field_type?.slug_name ||
                      questionsFieldTypeList.data.find(
                        (type) =>
                          type.id === question.field_type.id
                      )?.slug_name
                      ]
                    }
                    alt={`${question.field_type.name} icon`}
                    width="22px"
                    mr={1}
                  />
                  <Paragraph
                    fontSize={1}
                    color={"gray.60"}
                    my={1}
                  >
                    {qIndex + 1} - {question.title} -{" "}
                    {question.field_type?.name ||
                      questionsFieldTypeList.data.find(
                        (type) => type.id === question.field_type.id
                      )?.name ||
                      ""}
                  </Paragraph>
                </Flex>
              );
            })}
          </GrayCard>
           ))}
            <Flex justifyContent={"end"} mt="2">
             <Button
               isDisabled={editingSectionIndex !== null}
             onClick={() => navigate(ROUTE.SETTINGS_FORMS)}
             >
              Finish
            </Button>
           </Flex>
        </Box>

























        // <Container>
        //   <Flex minHeight="25vh">
        //     <H3 fontSize="3">
        //       Summary
        //     </H3>

        //   </Flex>
        //   <Flex justifyContent={"end"}>
        //     <Button
        //       isDisabled={editingSectionIndex !== null}
        //       onClick={() => navigate(ROUTE.SETTINGS_FORMS)}
        //     >
        //       Finish
        //     </Button>
        //   </Flex>
        // </Container>
      )}
    </>
  )
};
export default SettingsSummaryView;
